import { render, staticRenderFns } from "./RollbackDiskBackup.vue?vue&type=template&id=9dafa6be&"
import script from "./RollbackDiskBackup.vue?vue&type=script&lang=js&"
export * from "./RollbackDiskBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports